// ImagesGrid.jsx
import { useFormContext } from 'react-hook-form'
import { useMethods } from '@shared/hooks/methods'

import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

import InfiniteMasonry from '@shared/components/InfiniteMasonry'

export default function Images({
    images,
    onCrop
}) {
    const {
        setValue,
        getValues
    } = useFormContext()
    const { showMessage } = useMethods()

    const deleteItem = id => {
        const prev = getValues('images')
        const index = prev.findIndex(i => i.id === id)
        const removedItem = prev[index]

        setValue(
            'images',
            prev.filter(i => i.id !== id)
        )

        let undone = false
        const timeoutId = setTimeout(() => {
            if (!undone) URL.revokeObjectURL(removedItem.url)
        }, 6000)

        showMessage({
            text: 'تم الحذف',
            action: {
                text: 'تراجع',
                onClick: () => {
                    undone = true
                    clearTimeout(timeoutId)
                    const current = getValues('images')
                    const restored = [...current]
                    restored.splice(index, 0, removedItem)
                    setValue('images', restored)
                    showMessage(null)
                }
            }
        })
    }

    return (
        <InfiniteMasonry
            items={images}
            renderItem={(image, isLast, lastRef) => (
                <Box
                    ref={isLast ? lastRef : null}
                    sx={{
                        position: 'relative',
                        maxHeight: 200,
                        overflow: 'hidden',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: 'divider'
                    }}
                >
                    <IconButton
                        size='small'
                        sx={{
                            top: 5,
                            position: 'absolute',
                            insetInlineEnd: 5,
                            zIndex: 1,
                            padding: .2,
                            backgroundColor: 'rgba(255, 255, 255, 0.5)',
                            '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.3)' }
                        }}
                        onClick={() => deleteItem(image.id)}
                    >
                        <CloseIcon fontSize='small' />
                    </IconButton>

                    <img
                        src={image.url || image.image}
                        onClick={onCrop}
                        style={{
                            width: '100%',
                            objectFit: 'cover',
                            display: 'block',
                        }}
                    />
                </Box>
            )}
        />
    )
}